import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';

import DashboardLayout from 'layout/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'component/Navbars/DashboardNavbar';
import DataTable from 'component/Tables/DataTable';

import StatusCell from './components/StatusCell';
import useDebounce from 'hook/useDebounce';
import { usePolicies } from 'api/getPolicies';
import ArgonInput from 'component/Argon/ArgonInput';
import { CircularProgress, InputAdornment } from '@mui/material';

const SearchPolicy = () => {
  // const [rows, setRows] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const debounceValue = useDebounce(inputValue, 700);
  const { data: rows, refetch, isLoading } = usePolicies(debounceValue);

  useEffect(() => {
    if (debounceValue) {
      findPolicy(debounceValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceValue]);

  const inputBlur = () => {
    if (debounceValue) {
      findPolicy(debounceValue);
    }
  };

  function findPolicy(value) {
    if (value.length > 2) {
      if (process.env.NODE_ENV === 'development') {
        console.log('find: ' + value);
      }
      refetch().catch(console.error);
    }
  }

  return (
    <DashboardLayout bgColor="success">
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <ArgonBox>
              <Card>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
                  <ArgonBox lineHeight={1}>
                    <ArgonTypography variant="h5" fontWeight="medium">
                      ค้นหากรมธรรม์
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonBox p={3}>
                  {/* <InputDebounce setRows={setRows} /> */}
                  <ArgonInput
                    placeholder="ค้นหาโดยชื่อ / เลขประจำตัว / เลขที่กรมธรรม์ / เลขที่คำสั่งซื้อ"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onBlur={inputBlur}
                    endAdornment={
                      isLoading && (
                        <InputAdornment position="end">
                          <CircularProgress color="inherit" size={20} />
                        </InputAdornment>
                      )
                    }
                    inputProps={{
                      'aria-label': 'serach',
                    }}
                  />
                </ArgonBox>
                <ArgonBox px={3}>
                  <DataTable
                    table={{
                      columns: [
                        { Header: 'ชื่อ', accessor: 'name' },
                        {
                          Header: 'เลขประจำตัว',
                          Cell: ({ row }) => row.original?.idCard || row.original?.alcode,
                        },
                        { Header: 'เลขที่กรมธรรม์', accessor: 'policyNo' },
                        {
                          Header: 'สถานะ',
                          Cell: ({ row }) => (
                            <StatusCell status={row.original.status} isSuccess={row.original.urlPolicyLocal} />
                          ),
                        },
                        {
                          Header: 'เลขที่คำสั่งซื้อ',
                          Cell: ({ row }) => (
                            <Link to={`/order/${row.original.invoiceId}`}>{row.original.invoiceId}</Link>
                          ),
                        },
                      ],
                      rows,
                    }}
                    entriesPerPage={{
                      defaultValue: 25,
                      entries: [25, 50, 100],
                    }}
                  />
                </ArgonBox>
              </Card>
            </ArgonBox>
          </Grid>
        </Grid>
      </ArgonBox>
    </DashboardLayout>
  );
};

export default SearchPolicy;
